import { useState } from "react";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Card from "@mui/material/Card";

import MDBox from "../../../components/MDBox";
import MDModal from "../../../components/MDModal";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";

import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";

export default function DeleteModal({ message, onOk, redirect, type }) {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  function handleOk() {
    setOpen(false);
    onOk();
    if (redirect) navigate(redirect);
  }

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  let iconColor = "#FFF";
  if (type === "device") iconColor = darkMode ? "#344767" : "#FFF";

  return (
    <>
      {type === "user" || type === "supplier" || type === "organism" || type === "model" ? (
        <MDButton
          variant="contained"
          color="error"
          sx={{ height: "40px" }}
          onClick={() => setOpen(true)}
        >
          Supprimer
        </MDButton>
      ) : type === "file" ? (
        <MDBox
          lineHeight={1}
          sx={{
            textAlign: "center",
            justifyContent: "center",
            marginTop: "-5px",
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <MDTypography
            sx={{
              "&:hover": {
                textDecoration: "underline",
              },
              display: "table-cell",
              verticalAlign: "middle",
              cursor: "pointer",
              textAlign: "center",
              width: "100%",
            }}
            display="block"
            color="error"
            variant="string"
            underline="hover"
            onClick={() => setOpen(true)}
          >
            <Icon sx={{ verticalAlign: "middle" }}>delete</Icon> Supprimer le fichier
          </MDTypography>
        </MDBox>
      ) : (
        <IconButton size="medium" disableRipple color="inherit" onClick={() => setOpen(true)}>
          <Icon style={{ color: iconColor }}>delete</Icon>
        </IconButton>
      )}
      <MDModal open={open} onClose={() => setOpen(false)}>
        <MDBox mt={25} mb={9}>
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={8}>
              <Card textAlign="center">
                <MDBox
                  mt={-5}
                  mb={2}
                  mx={2}
                  variant="gradient"
                  bgColor="error"
                  borderRadius="lg"
                  coloredShadow="error"
                  textAlign="center"
                >
                  <MDBox mt={2} mb={2}>
                    <MDTypography variant="h3" fontWeight="bold" style={{ color: "#FFF" }}>
                      Supression de {decodeURIComponent(message)}
                    </MDTypography>
                  </MDBox>
                </MDBox>

                <MDBox mt={2} mb={4} textAlign="center">
                  <MDTypography variant="h5" fontWeight="regular" mb={3}>
                    Voulez-vous vraiment supprimer {decodeURIComponent(message)} ?
                  </MDTypography>
                  <MDButton
                    style={{ height: 44.13, width: "10%", marginRight: "1rem" }}
                    variant="contained"
                    color="success"
                    onClick={() => setOpen(false)}
                  >
                    Annuler
                  </MDButton>
                  <MDButton
                    style={{ height: 44.13, width: "10%" }}
                    variant="contained"
                    color="error"
                    onClick={handleOk}
                  >
                    Supprimer
                  </MDButton>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDModal>
    </>
  );
}

DeleteModal.propTypes = {
  message: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
  redirect: PropTypes.string,
  type: PropTypes.string,
};
